import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { FaMoneyBillWave, FaHardHat, FaBookOpen, FaSquare } from 'react-icons/fa';
import AuthContext from '../../context/AuthContext';
import { useLicense } from '../../context/LicenseContext';
import LicenseStatusBadge from '../license/LicenseStatusBadge';

const Header = () => {
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate('/');
  };

  const adminLinks = (
    <>
      <Nav.Link as={Link} to="/admin/dashboard">Dashboard</Nav.Link>
      <Nav.Link as={Link} to="/admin/customers">Customers</Nav.Link>
      <NavDropdown title="Management" id="admin-dropdown">
        <NavDropdown.Item as={Link} to="/admin/customers/create">Create Customer</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/admin/users">Users</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/admin/users/create">Create User</NavDropdown.Item>
      </NavDropdown>
    </>
  );

  const customerLinks = (
    <>
      <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
      <Nav.Link as={Link} to="/projects">Projects</Nav.Link>
      <Nav.Link as={Link} to="/clients">Clients</Nav.Link>
      <Nav.Link as={Link} to="/employees">Employees</Nav.Link>
      <NavDropdown title="Accounting" id="accounting-dropdown">
        <NavDropdown.Item as={Link} to="/payments"><FaMoneyBillWave className="me-1" /> Payment Tracking</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/subcontractors"><FaHardHat className="me-1" /> Subcontractors</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/mileage">Mileage Log</NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.Item as={Link} to="/quickbooks"><FaBookOpen className="me-1" /> QuickBooks</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/square"><FaSquare className="me-1" /> Square Payroll</NavDropdown.Item>
      </NavDropdown>
      <NavDropdown title="Reports" id="reports-dropdown">
        <NavDropdown.Item as={Link} to="/reports">All Reports</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/mileage/report">Mileage Report</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/reports/profitability">Job Profitability</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/reports/1099">1099 Report</NavDropdown.Item>
      </NavDropdown>
    </>
  );

  const authLinks = (
    <>
      <Nav className="me-auto">
        {user?.isAdmin ? adminLinks : customerLinks}
      </Nav>
      <Nav className="align-items-center">
        {/* License Status Badge - only show for customers, clickable to go to license management */}
        {!user?.isAdmin && isAuthenticated && (
          <div className="d-none d-lg-block me-3">
            <Link to="/license" style={{ textDecoration: 'none' }}>
              <LicenseStatusBadge />
            </Link>
          </div>
        )}
        <NavDropdown title={user?.Username || 'User'} id="user-dropdown">
          <NavDropdown.Item onClick={onLogout}>Logout</NavDropdown.Item>
        </NavDropdown>
      </Nav>
    </>
  );

  const guestLinks = (
    <Nav className="ms-auto">
      <Nav.Link as={Link} to="/">Login</Nav.Link>
      <Nav.Link as={Link} to="/admin">Admin Login</Nav.Link>
    </Nav>
  );

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to={isAuthenticated ? (user?.isAdmin ? '/admin/dashboard' : '/dashboard') : '/'}>
          Construction Management System
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {isAuthenticated ? authLinks : guestLinks}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
